/**
 * Date-extensions locale Sinhalese [si]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('si', {
    monthNames: ['ජනවාරි','පෙබරවාරි','මාර්තු','අප්‍රේල්','මැයි','ජූනි','ජූලි','අගෝස්තු','සැප්තැම්බර්','ඔක්තෝබර්','නොවැම්බර්','දෙසැම්බර්'],
    monthShortNames: ['ජන','පෙබ','මාර්','අප්','මැයි','ජූනි','ජූලි','අගෝ','සැප්','ඔක්','නොවැ','දෙසැ'],
    dayNames: ['ඉරිදා','සඳුදා','අඟහරුවාදා','බදාදා','බ්‍රහස්පතින්දා','සිකුරාදා','සෙනසුරාදා'],
    dayShortNames: ['ඉරි','සඳු','අඟ','බදා','බ්‍රහ','සිකු','සෙන']
});
